exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.textBox___19jdv {\n  margin: 12px 0;\n}\n.backButtonBox___FQJhB {\n  margin: auto;\n  margin-top: 20px;\n}\n.orderListingBox___24YhF {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: -12px;\n}\n.orderTileBox___25242 {\n  border-radius: 4px;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n  justify-content: space-between;\n  margin: 12px;\n}\n.orderTilePreview___2asbs {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  min-height: 225px;\n}\n.orderTileDetails___3MtRt {\n  padding: 12px;\n}\n.orderTileTitle___8zUQI {\n  font-size: 16px;\n  font-weight: 600;\n}\n.orderTileDate___1egat {\n  font-size: 12px;\n}\n.orderTileLink___3R3cI {\n  margin-top: 12px;\n}\n.box___1IFzO {\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  padding: 40px;\n}\n", ""]);

// exports
exports.locals = {
	"textBox": "textBox___19jdv",
	"backButtonBox": "backButtonBox___FQJhB",
	"orderListingBox": "orderListingBox___24YhF",
	"orderTileBox": "orderTileBox___25242",
	"orderTilePreview": "orderTilePreview___2asbs",
	"orderTileDetails": "orderTileDetails___3MtRt",
	"orderTileTitle": "orderTileTitle___8zUQI",
	"orderTileDate": "orderTileDate___1egat",
	"orderTileLink": "orderTileLink___3R3cI",
	"box": "box___1IFzO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/SampleLimitView/styles.module.less
// module id = 1628
// module chunks = 51